import { createEvent, createStore, sample } from 'effector';
import { setInterval, clearInterval } from 'worker-timers';

export const startQuestionTimer = createEvent();
export const stopQuestionTimer = createEvent();
export const resetQuestionTimer = createEvent();

// Внутреннее событие для обновления таймера
const tick = createEvent();

export const $questionTimer = createStore(0)
  .on(tick, (time) => time + 1) // Увеличиваем время на 1 каждую секунду
  .reset(resetQuestionTimer);

let intervalId: number | null;

sample({
  clock: startQuestionTimer,
  fn: () => {
    if (!intervalId) {
      intervalId = setInterval(() => {
        tick();
      }, 1000);
    }
  },
});

sample({
  clock: stopQuestionTimer,
  fn: () => {
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }
  },
});

sample({
  clock: resetQuestionTimer,
  fn: () => {
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }
  },
});
